import styled from "styled-components";

export const MainContainer = styled.main`
    width: 100%;
    min-height: 60vh;
    padding-top: 9vh;

    @media screen and (min-width: 768px) {
        padding-top: 0;
    }
`;
